import { useTranslation } from "react-i18next";
import { Alert } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import CustomButton from "Components/CustomButton";

const ErrorLoadingPayPal = ({ createPayPalButton, setSelectPaymentMethod, paypalClientId, customStyle }) => {
  const { t } = useTranslation();
  return (
    <div className="payment-error">
      <div className="error">
        <div className="alerts">
          {paypalClientId === undefined && (
            <Alert
              message={t("paypal.errorNoClientTitle")}
              description={t("paypal.errorDescription")}
              type="error"
              showIcon
            />
          )}
          {paypalClientId !== undefined && (
            <Alert
              message={t("paypal.errorRequestTitle")}
              description={t("paypal.errorDescription")}
              type="error"
              showIcon
            />
          )}
        </div>
        <div style={{ textAlign: "center" }}>
          <CustomButton buttonStyle={customStyle} type="primary" onClick={() => createPayPalButton(true)}>
            {t("paypal.retryButton")} <ReloadOutlined />
          </CustomButton>
        </div>
        <div style={{ textAlign: "center" }}>
          <CustomButton buttonStyle={customStyle} type="link" onClick={() => setSelectPaymentMethod({ visible: true })}>
            {t("paypal.changeMethodButton")}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default ErrorLoadingPayPal;
